import { useEffect, useState } from 'react';
import useMediaQuery from './hooks/useMediaQuery';
import DotGroup from './scenes/DotGroup';
import Navbar from './scenes/Navbar';
import Landing from './scenes/Landing';
import LineGradient from './components/LineGradient';
import Myskills from './scenes/Myskills';
import Projects from './scenes/Projects';
import Experience from './scenes/Experience';
import Contact from './scenes/Contact';
import { motion } from 'framer-motion';
import Footer from './scenes/Footer';
function App() {
  const [selectedPage, setSelectedPage] = useState('home');
  const [isTopOfPage, setIsTopOfPage] = useState(true);
  const isAboveMediumScreens = useMediaQuery('(min-width: 1060px)');

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY === 0) {
        setIsTopOfPage(true);
        setSelectedPage("home");
      }
      if (window.scrollY !== 0) setIsTopOfPage(false);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return (
    <div className="app bg-deep-blue">
      <Navbar
      isTopOfPage={isTopOfPage}
      selectedPage={selectedPage}
      setSelectedPage={setSelectedPage}
      />
      <div className="w-5/6 mx-auto md:h-full">
        {isAboveMediumScreens &&
        (
          <DotGroup
          selectedPage={selectedPage}
          setSelectedPage={setSelectedPage}

          />
        )}
        <motion.div
        margin="0 0 -200px 0"
        amount="all"
        onViewportEnter={() => setSelectedPage("home")}
        >
        <Landing setSelectedPage={setSelectedPage}/>
        </motion.div>
      </div>


      <LineGradient />
      <div className='w-5/6 mx-auto md:h-auto'>
      <motion.div
        margin="0 0 -200px 0"
        amount="all"
        onViewportEnter={() => setSelectedPage("skills")}
        >
        <Myskills />
        </motion.div>
      </div>




      <LineGradient />
      <div className='w-5/6 mx-auto '>
      <motion.div
        margin="0 0 -200px 0"
        amount="all"
        onViewportEnter={() => setSelectedPage("projects")}
        >
        <Projects />
        </motion.div>
      </div>

      <LineGradient />
      <div className='w-5/6 mx-auto md:h-auto'>
      <motion.div
        margin="0 0 -200px 0"
        amount="all"
        onViewportEnter={() => setSelectedPage("experience")}
        >
        <Experience />
        </motion.div>
      </div>
      
      <LineGradient />
      <div className='w-5/6 mx-auto md:h-auto'>
      <motion.div
        margin="0 0 -200px 0"
        amount="all"
        onViewportEnter={() => setSelectedPage("contact")}
        >
        <Contact />
        </motion.div>
      </div>
      <Footer />
    </div>
  );
}

export default App;
